class Wishlist extends HTMLElement {
    constructor() {
        super();
        this.wishlistButton = this.querySelector('.wishlist-button');
        
        const empiValue = (this.wishlistButton && this.wishlistButton.dataset && this.wishlistButton.dataset.productEmpi); // rwritten to not use condition chainging
        const empi = empiValue ? empiValue : '';
        if (empi) {
            this.actionButton = document.querySelector(`.wishlist-action-btn[data-product-empi="${empi}"]`);

            if (this.wishlistButton) {
                this.wishlistButton.addEventListener('click', () => this.onClick(this.wishlistButton));
            }

            if (this.actionButton) {
                this.actionButton.addEventListener('click', () => this.onClick(this.wishlistButton));
            }

            this.updateButtonState();
            this.setupObserver();
        }
    }

    setupObserver() {
        const callback = (mutationsList) => {
            for (const mutation of mutationsList) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    this.updateButtonState();
                }
            }
        };

        const observer = new MutationObserver(callback);
        observer.observe(this.wishlistButton, { attributes: true });
    }

    updateButtonState() {
        let actionText;
        
        if (this.wishlistButton.classList.contains('wishlist-added')) {
            actionText = 'Remove from Wishlist';
        } else {
            actionText = 'Add to Wishlist';
        }
    
        if (this.actionButton) {
            this.actionButton.innerText = actionText;
        }
    }
    
    onClick(wishlistButton) {
      let wishlistPage = document.querySelector('.wishlist-page');
      let isWishlistPage = wishlistPage != null;
      wishlistButton = this.wishlistButton;
      let epi = wishlistButton.dataset.productEpi;
      let iu = wishlistButton.dataset.productIu;
      let du = wishlistButton.dataset.productDu;
      let empi = wishlistButton.dataset.productEmpi;

      let wishlistItems = [];


      window._swat.fetch( function(data) {
        data.forEach(element => {
            wishlistItems.push(element.empi);
        });

        if (!wishlistItems.includes(Number(empi))) {
            window._swat.addToWishList(
                {
                "epi": epi,
                "du": du,
                "empi": empi,
                "iu" : iu
                },
                function(r) {
                    wishlistButton.classList.add('wishlist-added');
                    // keep in for testing color swatch
                    // console.log('Added to wishlist');
                    if (this.actionButton) {
                        this.actionButton.innerText = 'Remove from Wishlist';
                    }
                }.bind(this)
            );
        } else {
            window._swat.removeFromWishList(
                {
                "epi": epi,
                "du": du,
                "empi": empi,
                "iu" : iu
                },
                function(r) {
                    wishlistButton.classList.remove('wishlist-added');
                    if (this.actionButton) {
                        this.actionButton.innerText = 'Add to Wishlist';
                    }
                    if (isWishlistPage) {
                        wishlistButton.closest('.grid__item').remove();
                    }
                    // keep in for testing color swatch
                    // console.log('Removed from wishlist');
                }.bind(this)
            );
        }
      }.bind(this))

    }
}

customElements.define('wishlist-button', Wishlist);
